import * as React from 'react'
import { ReactElement } from 'react'
import { ITextFieldProps, TextField } from '@fluentui/react'
import { FormikContextType } from 'formik'
import { getFieldNameValue } from '../../../helpers/formHelper'

type Props<Values> = Omit<ITextFieldProps, 'value'> & {
    context: FormikContextType<Values>
    label: string
    fieldName: string
    textFieldProps?: Omit<ITextFieldProps, 'label'>
}

// noinspection JSUnusedGlobalSymbols
export default function FormikTextField<Values>(props: Props<Values>): ReactElement {
    const { values, errors, handleChange, handleBlur } = props.context

    return (
        <TextField
            label={props.label}
            value={getFieldNameValue(values, props.fieldName) ?? ''}
            errorMessage={errors?.[props.fieldName]?.toString()}
            onChange={handleChange(props.fieldName)}
            onBlur={handleBlur(props.fieldName)}
            {...(props.textFieldProps || {})}
        />
    )
}
